import { createBrowserRouter, Navigate } from 'react-router-dom';
import { AppLayout } from './components/layout/AppLayout';
import { ProtectedRoute } from './components/ProtectedRoute';
import { LoginPage } from './pages/LoginPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { DashboardPage } from './pages/dashboard/DashboardPage';
import { CompaniesPage } from './pages/dashboard/CompaniesPage';
import { UsersPage } from './pages/dashboard/UsersPage';
import { SitesPage } from './pages/dashboard/SitesPage';
import { WellsPage } from './pages/dashboard/WellsPage';
import { WellFormPage } from './pages/dashboard/WellFormPage';
import { AnnotationsPage } from './pages/dashboard/AnnotationsPage';
import { InventoryPage } from './pages/dashboard/InventoryPage';
import { ToolModelsPage } from './pages/dashboard/ToolModelsPage';
import { ThreeDModelPage as ThreeDModelsPage } from './pages/dashboard/ThreeDModelPage';
import { ChangePasswordPage } from './pages/dashboard/ChangePasswordPage';

export const router = createBrowserRouter([
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    element: <ProtectedRoute />,
    children: [
      {
        element: <AppLayout />,
        children: [
          {
            path: '/dashboard',
            element: <DashboardPage />,
          },
          {
            path: '/dashboard/companies',
            element: <CompaniesPage />,
          },
          {
            path: '/dashboard/users',
            element: <UsersPage />,
          },
          {
            path: '/dashboard/sites',
            element: <SitesPage />,
          },
          {
            path: '/dashboard/wells',
            element: <WellsPage />,
          },
          {
            path: '/dashboard/wells/new',
            element: <WellFormPage />,
          },
          {
            path: '/dashboard/wells/edit/:id',
            element: <WellFormPage />,
          },
          {
            path: '/dashboard/annotations',
            element: <AnnotationsPage />,
          },
          {
            path: '/dashboard/inventory',
            element: <InventoryPage />,
          },
          {
            path: '/dashboard/tool-models',
            element: <ToolModelsPage />,
          },
          {
            path: '/dashboard/3d-models',
            element: <ThreeDModelsPage />,
          },
          {
            path: '/dashboard/change-password',
            element: <ChangePasswordPage />,
          },
        ],
      },
    ],
  },
  {
    path: '/',
    element: <Navigate to="/dashboard" replace />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
]);
